import { create } from 'zustand'

import { fetchCourses } from '@/core/api/coursesService'

import type { Course } from './types'

interface CourseState {
  courses: Course[]
  coursesError: string | null
  loadCourses: () => Promise<void>
}

export const useCourseStore = create<CourseState>((set) => ({
  courses: [],
  coursesError: null,

  loadCourses: async () => {
    try {
      const apiCourses = await fetchCourses()
      const courses: Course[] = apiCourses.map((c) => ({
        ...c,
        isActive: c.isActive ?? true,
        order: c.order ?? 0,
      }))
      set({ courses, coursesError: null })
    } catch (err) {
      // Never fall back to demo data: keep the (possibly empty) list as-is and
      // surface the error so the UI does not show fake courses.
      console.error('[CourseStore] loadCourses failed:', err)
      set({ coursesError: err instanceof Error ? err.message : 'Failed to load courses' })
    }
  },
}))
